export const getFileExtension = (params: string) => {
  return params.split('.').pop();
};
